import React from 'react';

const HomeIcon = ({ fill = "#5E5E5E", className = "", ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none" className={className} {...props}>
        <path d="M2 16.6708H5V10.6708H11V16.6708H14V7.67078L8 3.17078L2 7.67078V16.6708ZM0 18.6708V6.67078L8 0.670776L16 6.67078V18.6708H9V12.6708H7V18.6708H0Z" fill={fill} />
    </svg>
);

export default HomeIcon;